import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const CircleRight = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.58594 4.58582C5.31817 3.85359 6.47715 3.80743 7.2627 4.44812L7.41406 4.58582L16 13.1718L24.5859 4.58582L24.7373 4.44812C25.5228 3.80736 26.6818 3.85365 27.4141 4.58582C28.1463 5.31807 28.1925 6.47702 27.5518 7.26257L27.4141 7.41394L18.8281 15.9999L27.4141 24.5858L27.5518 24.7372C28.1926 25.5227 28.1463 26.6817 27.4141 27.4139C26.6818 28.1462 25.5229 28.1924 24.7373 27.5516L24.5859 27.4139L16 18.828L7.41406 27.4139C6.63301 28.195 5.36699 28.195 4.58594 27.4139C3.80499 26.6329 3.80492 25.3668 4.58594 24.5858L13.1719 15.9999L4.58594 7.41394L4.44824 7.26257C3.80755 6.47703 3.85371 5.31804 4.58594 4.58582Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
    </svg>
  );
};

export default CircleRight;
